import aa from 'search-insights';

aa('init', {
  appId: process.env.GATSBY_ALGOLIA_APP_ID,
  apiKey: process.env.GATSBY_ALGOLIA_SEARCH_KEY,
});

export const algoliaAnalytics = aa;
